module.exports = __webpack_public_path__ + "img/3.02417f65.png";